// AdminUsers.jsx
import { useEffect, useState } from 'react';
import { getAdminUsers, toggleUserStatus } from '../../services/api';
import toast from 'react-hot-toast';
import { Search, UserCheck, UserX } from 'lucide-react';

export function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = (s = '') => {
    setLoading(true);
    getAdminUsers({ search: s, limit: 100 }).then(r => setUsers(r.data.users)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleToggle = async (id) => {
    await toggleUserStatus(id);
    setUsers(u => u.map(x => x.id === id ? { ...x, is_active: !x.is_active } : x));
    toast.success('User status updated.');
  };

  return (
    <div className="space-y-5 animate-fade-up">
      <div><h1 className="text-2xl font-bold text-gray-900 font-heading">Users</h1><p className="text-sm text-gray-500">{users.length} registered users</p></div>
      <div className="relative max-w-sm">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input className="input-field pl-9 py-2.5 text-sm" placeholder="Search users..." value={search} onChange={e => { setSearch(e.target.value); load(e.target.value); }} />
      </div>
      <div className="card border border-gray-100 overflow-hidden p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>{['Name', 'Email', 'Phone', 'Bookings', 'Joined', 'Status', 'Actions'].map(h => <th key={h} className="text-left px-4 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? <tr><td colSpan={7} className="text-center py-10 text-gray-400">Loading...</td></tr> :
                users.map(u => (
                  <tr key={u.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-semibold text-gray-900">{u.first_name} {u.last_name}</td>
                    <td className="px-4 py-3 text-gray-600">{u.email}</td>
                    <td className="px-4 py-3 text-gray-600">{u.phone || '—'}</td>
                    <td className="px-4 py-3 text-gray-600">{u.booking_count}</td>
                    <td className="px-4 py-3 text-gray-500 text-xs">{new Date(u.created_at).toLocaleDateString()}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${u.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {u.is_active ? <UserCheck size={11} /> : <UserX size={11} />} {u.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <button onClick={() => handleToggle(u.id)} className="text-xs text-gray-600 hover:text-purple-700 border border-gray-200 hover:border-purple-300 px-2.5 py-1 rounded-lg transition-colors">
                        {u.is_active ? 'Deactivate' : 'Activate'}
                      </button>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminUsers;
